"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTimeout = setTimeout;
exports.removeTimeout = removeTimeout;
exports.setInterval = setInterval;
exports.removeInterval = removeInterval;
const adapter_1 = require("../../api/adapter");
const timeoutHandlers = new WeakMap();
/**
 * Adds a timeout to the device and keeps track of the timeout id.
 * It's unique per function and guarantees that only one timeout is set per function.
 *
 * @example
 * ```ts
 * function sayHello() {
 *   console.log("Hello");
 * }
 *
 * addTimeout(sayHello, 1000);
 * addTimeout(sayHello, 1000); // The previous timeout is removed and a new one is set
 * ```
 */
function setTimeout(fn, delay) {
    removeTimeout(fn);
    const id = adapter_1.device.setTimeout(fn, delay);
    // console.log("!!! setTimeout id", fn.name, id);
    timeoutHandlers.set(fn, id);
    return id;
}
/**
 * Removes a timeout from the device by the function.
 *
 * @example
 * ```ts
 * function sayHello() {
 *   console.log("Hello");
 * }
 *
 * addTimeout(sayHello, 1000);
 * removeTimeout(sayHello); // The timeout is removed
 * ```
 */
function removeTimeout(fn) {
    const id = timeoutHandlers.get(fn);
    if (id != null) {
        adapter_1.device.clearTimeout(id);
        return id;
        // console.log("!!! clearTimeout id", fn.name, id);
    }
    return null;
}
/**
 * Adds an interval to the device and keeps track of the interval id.
 * It's unique per function and guarantees that only one interval is set per function.
 *
 * @example
 * ```ts
 * function sayHello() {
 *   console.log("Hello");
 * }
 *
 * addInterval(sayHello, 1000);
 * addInterval(sayHello, 1000); // The previous interval is removed and a new one is set
 * ```
 */
function setInterval(fn, delay) {
    removeInterval(fn);
    const id = adapter_1.device.setInterval(fn, delay);
    timeoutHandlers.set(fn, id);
    return id;
}
/**
 * Removes an interval from the device by the function.
 *
 * @example
 * ```ts
 * function sayHello() {
 *   console.log("Hello");
 * }
 *
 * addInterval(sayHello, 1000);
 * removeInterval(sayHello); // The interval is removed
 * ```
 */
function removeInterval(fn) {
    const id = timeoutHandlers.get(fn);
    if (id != null) {
        adapter_1.device.clearInterval(id);
    }
}
//# sourceMappingURL=timeout-helpers.js.map